import { queryOptions, useQuery } from '@tanstack/react-query';

import { makeIsEnabled } from '@cast/utils';

import { apiClient } from '@cast/infrastructure-api';

const NODE_STORAGE_QUERY_KEY = 'node-storage-metrics';
const getNodeStorageQueryKey = (params: { clusterId: string | undefined }) =>
  [NODE_STORAGE_QUERY_KEY, params.clusterId] as const;

const getNodeStorageQueryOptions = ({
  clusterId,
  enabled = true,
}: {
  clusterId: string | undefined;
  enabled?: boolean;
}) =>
  queryOptions({
    queryKey: getNodeStorageQueryKey({ clusterId }),
    queryFn: async () => {
      const { data } = await apiClient.costReport.getClusterNodesStorageReport({
        clusterId: clusterId!,
      });
      return data;
    },
    enabled: makeIsEnabled(enabled, !!clusterId),
  });

type UseNodeStorageQueryArgs = {
  clusterId?: string;
  enabled?: boolean;
};

export const useNodeStorageQuery = ({
  clusterId,
  enabled = true,
}: UseNodeStorageQueryArgs = {}) => {
  const { isLoading, data, error, refetch } = useQuery(
    getNodeStorageQueryOptions({
      clusterId,
      enabled,
    })
  );

  return { data, isLoading, error, refetch };
};
